import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import "./BasisTypes.scss";
/** Lazily Loaded Components */
const BasisTypesList = lazy(() =>
  import("./components/basisTypesList/BasisTypesList")
);
const AddEditBasisType = lazy(() =>
  import("./components/addEditBasisType/AddEditBasisType")
);

const BasisTypes = () => {
  const molGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [isUserModelOpen, setIsUserModelOpen] = useState(false);

  const handleAddUserClick = () => {
    setIsUserModelOpen(true);
    setEditUserData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsUserModelOpen(false);
    setEditUserData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsUserModelOpen(true);
    setEditUserData(data);
    setIsEdit(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="basis-types">
        <CardSection
          cardTitle={"Basis Types"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddUserClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
            <BasisTypesList ref={molGridRef} onEdit={handleEditClick} />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Basis Type` : `Add Basis Type`}
        modalSize={"w-40"}
        isOpen={isUserModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditBasisType
          isEdit={isEdit}
          isOpen={isUserModelOpen}
          initData={editUserData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

export default BasisTypes;
